<template>
    <div>
        <div v-show="parentShow">
            <Form :model="formItem" :label-width="80" inline>
                <Form-item label="标题">
                    <Input type="text" v-model="formItem.title"></Input>
                </Form-item>
                <Form-item label="内容">
                    <Input type="text" v-model="formItem.content"></Input>
                </Form-item>
                <Form-item label="状态">
                    <Select v-model="formItem.state" placeholder="请选择" style="width:200px">
                        <Option v-for="(item,index) in stateData" :key="index" :value="item.val">{{item.name}}</Option>
                    </Select>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="init">查询</Button>
                </Form-item>
                <Form-item>
                    <Button type="primary" class="ivu-form-item" @click="add">发布推送</Button>
                </Form-item>
            </Form>
            <Table border :columns="columns" :data="data"></Table>
            <div class="clearfix page">
                <Page :total="pageTotal" class="fr" @on-change="pageChange" @on-page-size-change="pageSize" :current="formItem.start+1" placement="top" show-elevator show-sizer></Page>
            </div>
            <el-dialog title="关闭活动" :visible.sync="closeShow">
                <p>确认要关闭活动？</p>
                <div slot="footer" class="dialog-footer">
                    <Button @click="closeShow=false">取 消</Button>
                    <Button type="primary" @click="remove">确 定</Button>
                </div>
            </el-dialog>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        data(){
            return{
                formItem: {
                    title:null,
                    content:null,
                    state:null,
                    start:0,
                    length:10,
                },
                stateData:[
                    {
                        val:'',
                        name:'全部'
                    },{
                        val:0,
                        name:'正常'
                    },{
                        val:1,
                        name:'关闭'
                    }
                ],
                bcid:'',
                data:[],
                pageTotal:0,
                closeShow:false,
                columns:[
                    {
                        title: '标题',
                        key: 'title'
                    },{
                        title: '内容',
                        key: 'content'
                    },{
                        title: '开始时间',
                        key: 'sdate'
                    },{
                        title: '结束时间',
                        key: 'edate'
                    },{
                        title: '创建时间',
                        key: 'cdate'
                    },{
                        title: '创建人',
                        key: 'username'
                    },{
                        title: '状态',
                        key: 'state'
                    },{
                        title: '操作',
                        key: 'id',
                        width: 150,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.see(params.row.bcid);
                                        }
                                    }
                                }, '查看'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{
                                        display:params.row.state == '关闭' ? 'none' : 'inline-block'
                                    },
                                    on: {
                                        click: () => {
                                            this.closeShow=true;
                                            this.bcid=params.row.bcid;
                                        }
                                    }
                                }, '关闭'),
                            ]);
                        }
                    }
                ],
            }
        },
        watch:{
            $route(to,from){
                this.$store.dispatch('parentShowFn');
                this.getData();
            }
        },
        computed: {
            parentShow () {
                return this.$store.state.parentShow;
            }
        },
        created(){
            this.$store.dispatch('parentShowFn');
            this.getData();
        },
        methods:{
            add(){
                this.$router.push('/pushNews/addNews')
            },
            see(id){
                this.$router.push({path:'/pushNews/seeNews',query:{bcid:id}});
            },
            remove(){
                this.closeShow=false;
                var _this=this;
                this.$http.get('/web/broadCast/deleteBroadCast',{
                    params:{
                        bcid:_this.bcid,
                    }
                }).then(function(res){
                    if(res.success){
                        _this.$Notice.success({
                            title: '关闭推送',
                            desc: res.message,
                        });
                        _this.getData();
                    }else{
                        _this.$Notice.error({
                            title: '关闭推送',
                            desc: res.message,
                        });
                    }
                }).catch(function(res){
                    _this.$Message.error(res.message);
                })
            },
            getData(){
                var _this=this;
                this.$http.get('/web/broadCast/listAllBroadCast',{
                    params:_this.formItem
                }).then(function(res){
                    _this.data=res.data;
                    _this.pageTotal=res.recordsTotal;
                    _this.$Message.success('加载成功');
                }).catch(function(res){
                    _this.$Message.error('加载失败');
                })
            },
            pageChange(res){
                this.formItem.start=res-1;
                this.getData();
            },
            pageSize(res){
                this.formItem.length=res;
            },
            init(){
                this.formItem.start=0;
                this.getData();
            },
        }
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/push/pushNews.vue